module.exports = __webpack_public_path__ + "assets/img/preview_02.c02dc65d.png";